import { render, staticRenderFns } from "./PorletGrafica.vue?vue&type=template&id=01172548&"
import script from "./PorletGrafica.vue?vue&type=script&lang=js&"
export * from "./PorletGrafica.vue?vue&type=script&lang=js&"
import style0 from "./PorletGrafica.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports